import { Link } from 'react-router-dom';
import ThemeToggle from '@/components/ThemeToggle';
import SmartLink from '@/components/SmartLink';
import { content } from '@/content/content';

// `focus-visible:outline-none` is deliberately absent — as a class rule it would
// override the global `a:focus-visible` outline and remove the focus indicator.
// `min-h-[44px]` because this is the header's only nav control at every width
// (the hamburger and its panel are gone); px-2/py-1 alone left a ~26px tap target.
const linkClass =
  'inline-flex min-h-[44px] items-center rounded px-2 font-mono text-xs font-medium uppercase tracking-[0.16em] text-[color:var(--fg-muted)] transition-colors hover:text-primary-ink dark:hover:text-primary';

/**
 * Single-page header: brand returns to the top, one in-page anchor, theme toggle.
 * Identical at every width — with one nav item there is nothing to collapse.
 */
const Navbar = (): JSX.Element => {
  const scrollToTop = (): void => window.scrollTo({ top: 0 });

  return (
    <nav className="nav-surface fixed inset-x-0 top-0 z-50 border-b border-[color:var(--hairline)] backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8">
        <Link
          to="/"
          onClick={scrollToTop}
          className="group flex items-center gap-2.5 rounded font-display text-lg font-bold tracking-nameplate text-[color:var(--fg)]"
        >
          <span className="h-3 w-3 shrink-0 bg-primary-dark transition-transform group-hover:rotate-45 dark:bg-primary" aria-hidden="true" />
          {content.nav.brand}
        </Link>

        <div className="flex items-center gap-3 sm:gap-5">
          {content.nav.links.map(({ to, label, ariaLabel }) => (
            <SmartLink key={to} to={to} ariaLabel={ariaLabel} className={linkClass}>
              {label}
            </SmartLink>
          ))}
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
